import React from "react";
import {Text, SimpleGrid, Stack, Divider, Link} from "@chakra-ui/core";

import Heading from "~/ui/display/Heading";
import Content from "~/ui/structure/Content";
import {useTranslation} from "~/i18n/hooks";

const sectionOne = (t) => [
  {
    id: "one",
    title: t("faqs.sectionOne.one.question"),
    description: t("faqs.sectionOne.one.answer"),
  },
  {
    id: "two",
    title: t("faqs.sectionOne.two.question"),
    description: t("faqs.sectionOne.two.answer"),
  },
  {
    id: "three",
    title: t("faqs.sectionOne.three.question"),
    description: t("faqs.sectionOne.three.answer"),
  },
  {
    id: "four",
    title: t("faqs.sectionOne.four.question"),
    description: t("faqs.sectionOne.four.answer"),
  },
  {
    id: "five",
    title: t("faqs.sectionOne.five.question"),
    description: t("faqs.sectionOne.five.answer"),
  },
  {
    id: "six",
    title: t("faqs.sectionOne.six.question"),
    description: t("faqs.sectionOne.six.answer"),
  },
  {
    id: "seven",
    title: t("faqs.sectionOne.seven.question"),
    description: t("faqs.sectionOne.seven.answer"),
  },
  {
    id: "eight",
    title: t("faqs.sectionOne.eight.question"),
    description: t("faqs.sectionOne.eight.answer"),
  },
];

const sectionTwo = (t) => [
  {
    id: "one",
    title: t("faqs.sectionTwo.one.question"),
    description: t("faqs.sectionTwo.one.answer"),
  },
  {
    id: "two",
    title: t("faqs.sectionTwo.two.question"),
    description: t("faqs.sectionTwo.two.answer"),
  },
  {
    id: "three",
    title: t("faqs.sectionTwo.three.question"),
    description: t("faqs.sectionTwo.three.answer"),
  },
];

const sectionThree = (t) => [
  {
    id: "one",
    title: t("faqs.sectionThree.one.question"),
    description: t("faqs.sectionThree.one.answer"),
  },
  {
    id: "two",
    title: t("faqs.sectionThree.two.question"),
    description: t("faqs.sectionThree.two.answer"),
  },
  {
    id: "three",
    title: t("faqs.sectionThree.three.question"),
    description: t("faqs.sectionThree.three.answer"),
  },
  {
    id: "four",
    title: t("faqs.sectionThree.four.question"),
    description: t("faqs.sectionThree.four.answer"),
  },
];

const sectionFour = (t) => [
  {
    id: "one",
    title: t("faqs.sectionFour.one.question"),
    description: t("faqs.sectionFour.one.answer"),
  },
  {
    id: "two",
    title: t("faqs.sectionFour.two.question"),
    description: t("faqs.sectionFour.two.answer"),
  },
  {
    id: "three",
    title: t("faqs.sectionFour.three.question"),
    description: t("faqs.sectionFour.three.answer"),
  },
  {
    id: "four",
    title: t("faqs.sectionFour.four.question"),
    description: t("faqs.sectionFour.four.answer"),
  },
  {
    id: "five",
    title: t("faqs.sectionFour.five.question"),
    description: t("faqs.sectionFour.five.answer"),
  },
  {
    id: "six",
    title: t("faqs.sectionFour.six.question"),
    description: t("faqs.sectionFour.six.answer"),
  },
  {
    id: "seven",
    title: t("faqs.sectionFour.seven.question"),
    description: t("faqs.sectionFour.seven.answer"),
  },
];

const sectionFive = (t) => [
  {
    id: "one",
    title: t("faqs.sectionFive.one.question"),
    description: t("faqs.sectionFive.one.answer"),
  },
  {
    id: "two",
    title: t("faqs.sectionFive.two.question"),
    description: t("faqs.sectionFive.two.answer"),
  },
  {
    id: "three",
    title: t("faqs.sectionFive.three.question"),
    description: t("faqs.sectionFive.three.answer"),
  },
  {
    id: "four",
    title: t("faqs.sectionFive.four.question"),
    description: t("faqs.sectionFive.four.answer"),
  },
];
const FAQs: React.FC = () => {
  const t = useTranslation();

  return (
    <Content backgroundColor="white" paddingX={6} paddingY={{base: 8, md: 16}}>
      <Stack alignItems="center" margin="auto" maxW="3xl">
        <Stack paddingY={{base: 4, md: 16}} spacing={{base: 10, md: 16}}>
          <Heading as="h2" fontSize={{base: "3xl", md: "4xl"}}>
            {t("faqs.sectionOne.name")}
          </Heading>
          <SimpleGrid columns={{base: 1}} gridGap={12}>
            {sectionOne(t).map((faq) => (
              <Stack
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                spacing={3}
                key={faq.title}
              >
                <Text as="h3" fontSize="lg" fontWeight="bold" itemProp="name">
                  {faq.title}
                </Text>
                <Text itemProp="text">{faq.description}</Text>
              </Stack>
            ))}
          </SimpleGrid>
        </Stack>
        <Divider />
        <Stack paddingY={{base: 4, md: 16}} spacing={{base: 10, md: 16}}>
          <Heading as="h2" fontSize={{base: "3xl", md: "4xl"}}>
            {t("faqs.sectionTwo.name")}
          </Heading>
          <SimpleGrid columns={{base: 1}} gridGap={12}>
            {sectionTwo(t).map((faq) => (
              <Stack
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                spacing={3}
                key={faq.title}
              >
                <Text as="h3" fontSize="lg" fontWeight="bold" itemProp="name">
                  {faq.title}
                </Text>
                <Text itemProp="text">{faq.description}</Text>
              </Stack>
            ))}
          </SimpleGrid>
        </Stack>
        <Divider />
        <Stack paddingY={{base: 4, md: 16}} spacing={{base: 10, md: 16}}>
          <Heading as="h2" fontSize={{base: "3xl", md: "4xl"}}>
            {t("faqs.sectionThree.name")}
          </Heading>
          <SimpleGrid columns={{base: 1}} gridGap={12}>
            {sectionThree(t).map((faq) => (
              <Stack
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                spacing={3}
                key={faq.title}
              >
                <Text as="h3" fontSize="lg" fontWeight="bold" itemProp="name">
                  {faq.title}
                </Text>
                <Text itemProp="text">{faq.description}</Text>
              </Stack>
            ))}
          </SimpleGrid>
        </Stack>
        <Divider />
        <Stack paddingY={{base: 4, md: 16}} spacing={{base: 10, md: 16}}>
          <Heading as="h2" fontSize={{base: "3xl", md: "4xl"}}>
            {t("faqs.sectionFour.name")}
          </Heading>
          <SimpleGrid columns={{base: 1}} gridGap={12}>
            {sectionFour(t).map((faq) => (
              <Stack
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                spacing={3}
                key={faq.title}
              >
                <Text as="h3" fontSize="lg" fontWeight="bold" itemProp="name">
                  {faq.title}
                </Text>
                <Text itemProp="text">{faq.description}</Text>
              </Stack>
            ))}
          </SimpleGrid>
        </Stack>
        <Divider />
        <Stack paddingY={{base: 4, md: 16}} spacing={{base: 10, md: 16}}>
          <Heading as="h2" fontSize={{base: "3xl", md: "4xl"}}>
            {t("faqs.sectionFive.name")}
          </Heading>
          <SimpleGrid columns={{base: 1}} gridGap={12}>
            {sectionFive(t).map((faq) => (
              <Stack
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                spacing={3}
                key={faq.title}
              >
                <Text as="h3" fontSize="lg" fontWeight="bold" itemProp="name">
                  {faq.title}
                </Text>
                <Text itemProp="text">{faq.description}</Text>
              </Stack>
            ))}
          </SimpleGrid>
        </Stack>
        <Stack
          backgroundColor="primary.50"
          borderRadius="lg"
          paddingX={6}
          paddingY={{base: 8, md: 16}}
          spacing={8}
        >
          <Text
            as="h3"
            fontSize={{base: "xl", md: "2xl"}}
            fontWeight="bold"
            textAlign={{base: "center"}}
          >
            ¿La solución a tu problema no se encuentra aquí? Contáctanos ¡Te responderemos lo antes
            posible!
          </Text>
          <Stack
            isInline
            display={{base: "none", md: "inherit"}}
            justifyContent="center"
            spacing={4}
          >
            <Link
              isExternal
              _hover={{color: "primary.900"}}
              borderColor="primary.500"
              borderRadius={4}
              borderWidth={2}
              color={"primary.500"}
              fontWeight="bold"
              href={`https://wa.me/5491166008088`}
              padding="2"
              textDecoration="none"
            >
              {t("faqs.hero.actionSecondary")}
            </Link>
          </Stack>
        </Stack>
      </Stack>
    </Content>
  );
};

export default FAQs;
